import { viewEmailLinkInNote } from './getEmailLinkForNote.locstring.json';
import loc, { format } from 'owa-localize';

import { getHostLocation } from 'owa-url/lib/hostLocation';

const MAIL_DEEPLINK_FORMAT = '{0}/owa/?ItemID={1}&viewmodel=ReadMessageItem&ispopout=1';

export default function getEmailLinkForNote(itemId: string): string {
    const emailLink = getEmailLink(itemId);

    return format(loc(viewEmailLinkInNote), emailLink);
}

export function getEmailLink(itemId: string): string {
    const hostLocation = getHostLocation();
    const origin = hostLocation.origin;
    const emailLink = format(MAIL_DEEPLINK_FORMAT, origin, encodeURIComponent(itemId));
    return emailLink;
}
